import { Box, Typography } from "@mui/material";
import { StoryCard } from "Components/Stories/Management/StoryCard";
import { StoryCardSkeleton } from "Components/Stories/Management/StoryCardSkeleton";
import type { StoryListItemDto } from "Infrastructure/Api/Api";
import type { ReactNode } from "react";

const MIN_CARD_WIDTH_PX = 200;
/** Cards stay compact instead of stretching to fill the row; leftover space is left empty. */
const MAX_CARD_WIDTH_PX = 230;
const SKELETON_KEYS = ["s1", "s2", "s3", "s4"];

type Props = {
  stories: Array<StoryListItemDto>;
  isLoading: boolean;
  isAuthorVisible: boolean;
  emptyText: string;
  renderActions: (story: StoryListItemDto) => ReactNode;
  onMediaClick: (story: StoryListItemDto) => void;
};

/** Responsive story card grid — the phone-friendly list for Merchant authors. */
export const StoryCardGrid = ({
  stories,
  isLoading,
  isAuthorVisible,
  emptyText,
  renderActions,
  onMediaClick,
}: Props) => {
  if (!isLoading && stories.length === 0) {
    return (
      <Typography color="text.secondary" py={4} textAlign="center">
        {emptyText}
      </Typography>
    );
  }

  return (
    <Box
      display="grid"
      gap={2}
      gridTemplateColumns={`repeat(auto-fill, minmax(${MIN_CARD_WIDTH_PX}px, ${MAX_CARD_WIDTH_PX}px))`}
    >
      {isLoading
        ? SKELETON_KEYS.map((key) => <StoryCardSkeleton key={key} />)
        : stories.map((story) => (
            <StoryCard
              key={story.publicID}
              story={story}
              isAuthorVisible={isAuthorVisible}
              actions={renderActions(story)}
              onMediaClick={() => onMediaClick(story)}
            />
          ))}
    </Box>
  );
};
